import { MAPBOX_TOKEN } from "./api";

/**
 * Geocode Italian address via Mapbox (same token as the simulator map).
 * @returns {{ latitude: number, longitude: number } | null}
 */
export async function geocodeItalianAddress({ address, city, province, postal_code }) {
  if (!MAPBOX_TOKEN) return null;
  const q = [address, city, province, postal_code, "Italia"]
    .map((s) => (s != null ? String(s).trim() : ""))
    .filter(Boolean)
    .join(", ");
  if (!q) return null;
  try {
    const url =
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(q)}.json` +
      `?access_token=${MAPBOX_TOKEN}&country=it&limit=1`;
    const r = await fetch(url);
    const d = await r.json();
    const f = d.features?.[0];
    if (!f?.center) return null;
    const [lng, lat] = f.center;
    return { latitude: lat, longitude: lng };
  } catch {
    return null;
  }
}
